///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API } from "./axios";

export const getUser = () => API.get("api/v1.0/users/profile");

export const getUserSetting = userId =>
  API.get("api/v1.0/users/settings", {
    params: {
      userId
    }
  });

export const putUserSetting = settings =>
  API.put("api/v1.0/users/settings", settings);

export const getUserNotificationSettings = () =>
  API.get("api/v1.0/users/notification-settings");

export const putNotificationSettings = settings =>
  API.put("api/v1.0/users/notification-settings", settings);

export const getUserSettingV2 = email =>
  API.get("api/v1.0/users/settings-v2", {
    params: {
      email
    }
  });
